import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import SupplyChainPage from "@/pages/service/SupplyChainPage";

export const Route = createFileRoute("/service/supply-chain")({
  head: () => pageHead("Supply Chain Management", "AI-powered supply chain optimization, supplier intelligence, demand forecasting, and logistics management.", "/service/supply-chain", false),
  component: SupplyChainPage,
});
